<template>
    <div class="wrapper">
        <side-bar :options="this.modulos" :class="{ collapsed: sidebarCollapsed }" :collapsed="sidebarCollapsed"
            :is-night.sync="isNight" @toggle-collapse="toggleSidebarCollapsed">
            <template v-slot:links>
                <sidebar-link v-for="(modulo, index) in modulos" :key="linkId(index)" :name="modulo.text"
                    :icon="modulo.icon" :collapsed="sidebarCollapsed" /> </template>
            <mobile-menu>
                <drop-down class="nav-item" title="5 Notifications" title-classes="nav-link" icon="ti-bell">
                    <a class="dropdown-item">Notification 1</a>
                    <a class="dropdown-item">Another notification</a>
                </drop-down>
                <li class="nav-item">
                    <a class="nav-link" href="#/cadastros/tipoprocessos">
                        <i class="ti-settings"></i>
                        <p>Settings -test</p>
                    </a>
                </li>
                <li class="divider"></li>
            </mobile-menu>
        </side-bar>
        <div class="main-panel" :class="{ collapsed: sidebarCollapsed }">
            <button v-if="sidebarCollapsed" class="sidebar-float-toggle" @click="toggleSidebarCollapsed">
                <b-icon icon="justify" font-scale="1.3" />
            </button>
            <top-navbar></top-navbar>
            <dashboard-content />
            <content-footer></content-footer>
        </div>
    </div>
</template>
<style lang="scss"></style>
<script>
import ContentFooter from "@/core/layout/ContentFooter.vue"
import DashboardContent from "./Content.vue"
import MobileMenu from "./MobileMenu"
import TopNavbar from "./TopNavbar.vue"

import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "../utils/PrivilegioEnum"
import verificaModulos from "@/utils/VerificaModulos"
import ModuloEnum from "@/core/utils/ModuloEnum"

let MODULOS = []

function childrenToMenuItem(path, children, meta, sistema) {
    const items = []


    for (const item of children) {

        if (item.children) {
            items.push(
                ...childrenToMenuItem(
                    `${path}/${item.path || ""}`,
                    item.children,
                    null,
                    sistema,
                )
            )
        }


        if (item.meta && item.meta.menu) {

            if (item != null && (item.meta.menu.permissao != PrivilegiosEnum.NAO_NECESSITA_PERMISSAO && !verificaPrivilegio(item.meta.menu.permissao, sistema)))
                continue;

            items.push({
                type: "sublink",
                routerName: item.name,
                ...item.meta.menu,
            })
        }

    }



    return items.sort((a, b) => a.name.trim().localeCompare(b.name.trim()))
}

export const registrarModuloMenu = (...routes) => {
    const modules = routes
        .filter((route) => !!route.meta.moduleName)
        .sort((a, b) => a.meta.moduleName.localeCompare(b.meta.moduleName))
        .map(({ path, meta, children }) => {

            var menuItems = []
            if (
                (!meta.permissoesEspeciais || meta.permissoesEspeciais.length == 0 || meta.permissoesEspeciais.some(p => verificaPrivilegio(p, meta.sistema))) &&
                (meta.modulo.cod === ModuloEnum.NAO_NECESSITA_VERIFICACAO.cod || verificaModulos(meta.modulo.cod, meta.sistema))) {
                menuItems = childrenToMenuItem(path, children, meta, meta.sistema)
            }

            return { sistema: meta.sistema, modulo: meta.modulo, value: meta.moduleName, icon: meta.icon, text: meta.moduleName, menu: menuItems }
        })
    /**
     * atravez do array abaixo e possivel alternar a ordem do menu a ordem correta que vem é 
     * 0 - almoxarifado
     * 1 - cadastros essenciais
     * 2 - compra
     * 3 - gerenciamentoF
     * 4 - patrimonio
     * 
     * foi alterado para 
     * 0 - almoxarifado
     * 4 - patrimonio
     * 2 - compra
     * 1 - cadastros essenciais
     * 3 - gerenciamento
     */
    let ordemMenu = [7, 3, 0, 8];

    let novoArray = ordemMenu.map((index) => modules[index])
    MODULOS.push(...novoArray)

    return novoArray
}
export default {
    components: {
        TopNavbar,
        ContentFooter,
        DashboardContent,
        MobileMenu,
    },
    data() {
        return {
            isNight: false,
            moduleChangedCount: 0,
            activeLinkIndex: 0,
            sidebarLinks: [],
            modulos: MODULOS,
            sidebarCollapsed: false,
        }
    },
    watch: {
        isNight(val) {
            if (val) document.body.classList.add("dark-mode");
            else document.body.classList.remove("dark-mode");
        },
        $MODULOS() {
        },
    },
    mounted() {
        this.activeLinkIndex = 0;
        this.sidebarLinks = [];

        this.modulos = this.modulos.map((modulo) => {
            modulo.menu = modulo.menu
                ? modulo.menu.map((item) => {
                    item.to = this.$router.resolve({ name: item.routerName }).href
                    return item
                })
                : modulo.menu

            return modulo
        })

        this.$root.$on("moduleChanged", (sidebarLinks) => {
            this.sidebarLinks = sidebarLinks
            this.moduleChangedCount++
        })
    },
    computed: {
        menuDepartamento() {
            return this.$store.getters.getMenuDepartamento
        },
    },
    methods: {
        toggleSidebar() {
            if (this.$sidebar && this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false)
            }
        },
        toggleSidebarCollapsed() {
            this.sidebarCollapsed = !this.sidebarCollapsed;
        },
        linkId(index) {
            return `${this.moduleChangedCount}:${index}`
        },
    },
}
</script>